import "./Header.scss";

import dtd from "../assets/events/dtd.webp";
import dtdbg from "../assets/backgrounds/dtd.mp4";

const Header = () => {
	return (
		<header className="header">
			<video autoPlay muted loop className="dtdbg">
				<source src={dtdbg} type="video/mp4" />
				<img className="eventlogo" src={dtd} alt="Destroy The Decibel" />
			</video>
		</header>
	);
};

export default Header;
